<template>
  <v-flex class="bucket-table-container" :class="{ 'search-result-table-container': resultTableMode }">
    <Loading :isLoading="bucketLoading">
      <v-data-table v-if="resultTableMode" :id="'dataTable-' + searchData.caseTypeId"
        :key="'rt-' + bucketDataTableKey"
        :ref="'dataTable-' + searchData.caseTypeId" :headers="formattedResult.headers" :items="resultTableItems"
        :total-items="vuetifyDataTableTotalItems" :pagination.sync="pagination" :rows-per-page-items="[5, 10, 20, 50, 100]"
        :custom-sort="dataTablePreserveApiRowOrder"
        disable-initial-sort
        select-all v-model="selected" class="my-custom-table box-shadow no-background search-result-data-table">
        <template v-slot:headers="props">
          <tr>
            <th v-if="taskToggled">
              <v-checkbox :input-value="allSelected" :indeterminate="indeterminateSelection" color="secondary"
                class="checkbox" hide-details @click.stop="toggleAll"></v-checkbox>
            </th>
            <th v-for="(header, headerIndex) in props.headers" :key="headerIndex"
              class="column text-xs-left"
              :class="[header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="setSortField(header)">
              {{ header.text }}
              <v-icon small v-if="header.sortable">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="checkbox" v-if="taskToggled">
            <v-checkbox color="secondary" hide-details v-model="selections[props.index]"></v-checkbox>
          </td>
          <td v-for="(header, headerIndex) in formattedResult.headers" class="viewer-column" :key="headerIndex">
            <BucketTableField :header="header" :data="cellValue(props.item, header.value, header.embedded)">
            </BucketTableField>
          </td>
        </template>
      </v-data-table>
      <!-- Normal Bucket table -->
      <v-data-table v-if="!resultTableMode" id="dataTable" ref="dataTable" :headers="headers" :items="bucketTableItems"
        :key="'bt-' + bucketDataTableKey"
        :total-items="vuetifyDataTableTotalItems" :pagination.sync="pagination" :rows-per-page-items="[5, 10, 20, 50, 100]"
        :custom-sort="dataTablePreserveApiRowOrder"
        disable-initial-sort
        select-all
        v-model="selected" class="my-custom-table no-background elevation-0">
        <template v-slot:headers="props">
          <tr>
            <th v-if="taskToggled">
              <v-checkbox :input-value="allSelected" :indeterminate="indeterminateSelection" color="secondary"
                class="checkbox" hide-details @click.stop="toggleAll"></v-checkbox>
            </th>
            <th v-if="showViewers">Case Presence</th>
            <th v-for="header in props.headers" :key="`header-${header.value}`"
              class="column text-xs-left"
              :class="[header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="setSortField(header)">
              {{ header.text }}
              <v-icon small v-if="header.sortable">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="checkbox" v-if="taskToggled">
            <v-checkbox color="secondary" hide-details v-model="selections[props.index]"></v-checkbox>
          </td>
          <td v-if="showViewers" class="viewer-column case-presence">
            <v-card flat class="bucket-field"> <case-presence-display :viewers="props.item.currentlyViewing"
                :viewerMax="1" :bucketView="true"> </case-presence-display> </v-card>
          </td>
          <td v-for="(header, headerIndex) in headers" class="viewer-column" :key="headerIndex">
            <BucketTableField :header="header" :data="cellValue(props.item, header.value, header.embedded)">
            </BucketTableField>
          </td>
        </template>
      </v-data-table>
    </Loading>
  </v-flex>
</template>

<script>
import { mapState } from "vuex"
import Loading from "@/components/shared/Loading.vue"
import BucketTableField from "@/components/buckets/bucket-edit/BucketTableField.vue"
import CasePresenceDisplay from "@/components/shared/CasePresenceDisplay"
import Helpers from "@/helpers.js"
import Vue from "vue"

export default {
  name: "bucket-table",
  components: { Loading, BucketTableField, CasePresenceDisplay },
  props: {
    dataProvider: Object,
    dataSearcher: Object,
    searchTerm: String,
    searchData: Object,
    selectedField: String,
    sortField: String,
    relationData: Object,
    resultTableMode: Boolean,
    taskToggled: Boolean,
    filterToggle: Boolean,
    currentFilter: {
      type: Object,
      required: true,
      default: () => ({
        active: false,
        field: "all_fields",
        term: "",
        itemCount: 0,
        page: 1,
        prevPage: 1,
        currentPage: 1,
      }),
    },
  },
  data: () => ({
    selected: [],
    dataChanged: false,
    hideActions: false,
    tasklists: [],
    runTasklist: { name: "", tasks: [] },
    runTask: {},
    currentPage: 1,
    prevPage: 1,
    sortBy: "",
    sortDesc: false,
    /** When false, do not pass sortField/sortDirection to the API — bucket DB sortFields define ES order (required for correct pagination). */
    columnSortExplicit: false,
    loadTimeStart: 0,
    formattedResult: {
      headers: [],
      cases: [],
    },
    selections: [false],
    scrollPosition: { x: 0, y: 0 },
    columnWidths: {},
  }),
  computed: {
    ...mapState({
      caseType: (state) => state.buckets.current.caseType,
      bucket: (state) => state.buckets.current.bucket,
      bucketHeaders: (state) => state.buckets.current.headers,
      bucketCases: (state) => state.buckets.current.cases,
      bucketLoading: (state) => state.buckets.current.loading,
      kpiFilter: (state) => state.buckets.kpiFilter,
      currentUser: (state) => state.currentUser.me,
      globalSearchTerm: (state) => (state.cbroute.params && state.cbroute.params.search_term) || "",
    }),
    caseTypeId() {
      const p = this.$store.state.cbroute.params
      const id = (p && p.case_type_id) != null ? p.case_type_id : (this.$route.params && this.$route.params.case_type_id)
      return parseInt(id, 10) || 0
    },
    bucketId() {
      const p = this.$store.state.cbroute.params
      const id = (p && p.bucket_id) != null ? p.bucket_id : (this.$route.params && this.$route.params.bucket_id)
      return parseInt(id, 10) || 0
    },
    headers() {
      return this.resultTableMode ? this.formattedResult.headers : this.bucketHeaders
    },
    cases() {
      return this.bucketCases
    },
    totalCases() {
      if (this.resultTableMode) {
        return this.searchData.total
      } else {
        let total = 0
        if (this.bucket) {
          if (this.bucket.contents && this.bucket.contents.statistics) {
            total = this.bucket.contents.statistics.total
          } else if (this.bucket.total) {
            total = this.bucket.total
          }
        }
        if (this.currentFilter.active) {
          total = this.currentFilter.itemCount
        }
        return total
      }
    },
    /**
     * Vuetify 1: when total-items is falsy (0), v-data-table runs client-side customSort.
     * sortBy "" is not treated as "no sort" (only null is), which reorders server-sorted rows incorrectly.
     * Keep total truthy whenever we have rows so the table shows items in API order.
     */
    serverSideTotalItems() {
      if (this.resultTableMode) {
        const t = this.searchData && this.searchData.total
        const n = typeof t === "number" && !isNaN(t) ? t : 0
        const rows = (this.formattedResult && this.formattedResult.cases && this.formattedResult.cases.length) || 0
        return Math.max(n, rows)
      }
      const nRaw = this.totalCases
      const n = typeof nRaw === "number" && !isNaN(nRaw) ? nRaw : 0
      const rows = (this.cases && this.cases.length) || 0
      return Math.max(n, rows)
    },
    /**
     * Vuetify 1: `if (this.totalItems) return this.items` — NaN/undefined coerces falsy and triggers client sort.
     * Always pass a positive integer when we have rows.
     */
    vuetifyDataTableTotalItems() {
      const raw = this.serverSideTotalItems
      const base = typeof raw === "number" && !isNaN(raw) ? raw : 0
      const rows = this.resultTableMode
        ? (this.formattedResult && this.formattedResult.cases && this.formattedResult.cases.length) || 0
        : (this.bucketCases && this.bucketCases.length) || 0
      const m = Math.max(base, rows)
      return m > 0 ? m : 0
    },
    /** Fresh array + stable key so v-data-table remounts when API id order changes (default bucket sort). */
    bucketTableItems() {
      const c = this.bucketCases
      if (!c || !c.length) {
        return []
      }
      return c.slice()
    },
    resultTableItems() {
      const c = this.formattedResult && this.formattedResult.cases
      if (!c || !c.length) {
        return []
      }
      return c.slice()
    },
    bucketDataTableKey() {
      if (this.resultTableMode) {
        const c = this.formattedResult && this.formattedResult.cases
        if (!c || !c.length) {
          return "0"
        }
        return c.map(function (p) {
          return p.id
        }).join("-")
      }
      const c = this.bucketCases
      if (!c || !c.length) {
        return "0"
      }
      return c.map(function (p) {
        return p.id
      }).join("-")
    },
    showViewers() {
      return this.bucket.showUserPresence ? this.bucket.showUserPresence : false
    },
    allSelected() {
      if (this.selections.length > 0) {
        return !this.selections.includes(false)
      } else {
        return false
      }
    },
    indeterminateSelection() {
      if (this.selections) {
        return this.selections.includes(false) && this.selections.includes(true)
      } else {
        return false
      }
    },
    reference() {
      return this.resultTableMode ? "dataTable-" + this.searchData.caseTypeId : "dataTable"
    },
    pagination: {
      get() {
        const sortByForTable =
          this.columnSortExplicit && this.sortBy && String(this.sortBy).trim() !== ""
            ? this.sortBy
            : null
        return {
          descending: this.sortDesc,
          page: this.currentPage,
          rowsPerPage: this.currentUser.preferences.pageSize,
          sortBy: sortByForTable,
          maxPagesShown: 15,
          totalItems: this.vuetifyDataTableTotalItems,
        }
      },
      set(newPagination) {
        let reload = false
        let resetToPageOne = false
        
        // Store scroll only — not column widths. Vuetify syncs pagination often during first
        // paint; measuring thead then captures bogus full-width columns until refresh.
        this.storeScrollPosition({ includeColumnWidths: false })
        
        if (newPagination.rowsPerPage !== this.currentUser.preferences.pageSize) {
          const prefs = {
            dateFormat: this.currentUser.preferences.dateFormat,
            dateTimeFormat: this.currentUser.preferences.dateTimeFormat,
            pageSize: newPagination.rowsPerPage,
            unifiedSearch: this.currentUser.preferences.unifiedSearch !== false,
            timeline: this.currentUser.preferences.timeline,
          }
          delete prefs.timeline.__typename
          this.$store.dispatch("updateCurrentUserPageSize", { id: this.currentUser.id, preferences: prefs })
          reload = true
          resetToPageOne = true
        }
        if (newPagination.descending !== this.pagination.descending) {
          if (this.columnSortExplicit) {
            this.sortDesc = newPagination.descending
            reload = true
          }
        }
        if (newPagination.sortBy !== this.pagination.sortBy) {
          if (this.columnSortExplicit) {
            this.sortBy = newPagination.sortBy
            reload = true
          }
        }
        if (newPagination.page !== this.pagination.page) {
          this.currentPage = newPagination.page
          reload = true
        }
        
        if (reload) {
          // Reset to page 1 if pagination settings changed
          if (resetToPageOne) {
            this.currentPage = 1
            newPagination.page = 1
          }
          
          this.updateUrlWithSortParams()
          if (this.searchData) {
            this.performFilter()
          } else {
            this.dataProvider.reload(
              newPagination.page,
              this.columnSortExplicit ? newPagination.sortBy : undefined,
              this.columnSortExplicit ? newPagination.descending : undefined
            ).then(() => {
              if (this.currentFilter.active) this.performFilter()
              // Restore scroll position after data loads
              this.$nextTick(() => {
                this.restoreScrollPosition()
              })
            })
          }
        }
      },
    },
  },
  watch: {
    selections() {
      const selectedIds = []
      for (let i = 0; i < this.selections.length; i++) {
        if (this.selections[i]) {
          if (this.resultTableMode) {
            selectedIds.push(parseInt(this.formattedResult.cases[i].id, 10))
          } else {
            selectedIds.push(parseInt(this.cases[i].id, 10))
          }
        }
      }
      this.$emit("selections-update", selectedIds)
    },
    bucketLoading(newVal, oldVal) {
      // When loading finishes (transitions from true to false), restore scroll position
      if (oldVal === true && newVal === false) {
        // Wait for next tick to ensure DOM is updated
        this.$nextTick(() => {
          this.restoreScrollPositionWhenReady()
        })
      }
    },
    cases() {
      // When cases data changes, restore scroll if we're not loading
      if (!this.bucketLoading && (this.scrollPosition.x !== 0 || this.scrollPosition.y !== 0)) {
        this.$nextTick(() => {
          this.restoreScrollPositionWhenReady()
        })
      }
    },
    formattedResult: {
      handler() {
        // When formattedResult changes (for resultTableMode), restore scroll if we're not loading
        if (!this.bucketLoading && (this.scrollPosition.x !== 0 || this.scrollPosition.y !== 0)) {
          this.$nextTick(() => {
            this.restoreScrollPositionWhenReady()
          })
        }
      },
      deep: true
    },
    bucket() {
      Vue.store.dispatch("unsubscribeFromBucketPresence")
      if (this.bucket && this.bucket.contents && this.bucket.contents.cases) {
        const caseIds = this.bucket.contents.cases.map((cas) => cas.id)
        this.$store.dispatch("subscribeToBucketPresence", { caseIds })
      }
    },
    relationData() {
      this.dataChanged = true
      this.refreshData()
    },
    bucketId() {
      this.columnWidths = {}
      this.dataChanged = true
      this.refreshData()
    },
    caseTypeId() {
      this.columnWidths = {}
      this.dataChanged = true
      this.refreshData()
    },
    searchTerm() {
      this.refreshData()
    },
    selectedField() {
      this.refreshData()
    },
    filterToggle() {
      this.prevPage = this.currentFilter.prevPage
      this.currentPage = this.currentFilter.currentPage
      this.pagination.page = this.currentFilter.page
      this.performFilter()
    },
    '$route'(to, from) {
      // Re-initialize sort from URL when route changes
      if (to.query.sortField !== from.query.sortField || to.query.sortDirection !== from.query.sortDirection) {
        this.initializeSortFromUrl()
      }
    },
  },
  created() {
    this.loadTimeStart = new Date().getTime()
    this.dataChanged = true
    this.initializeSortFromUrl()
    this.refreshData()
  },
  methods: {
    /**
     * Vuetify 1 data-iterable: if total-items is falsy, it runs default customSort by pagination.sortBy.
     * That re-sorts formatted cell values (e.g. dates as strings) and no longer matches Elasticsearch.
     */
    dataTablePreserveApiRowOrder(items /*, sortBy, descending */) {
      return items
    },
    setSortField(header) {
      if (header.sortable) {
        // Store scroll position before sorting
        this.storeScrollPosition()
        
        if (this.sortBy === header.value && this.sortDesc) {
          this.sortBy = ""
          this.sortDesc = false
          this.columnSortExplicit = false
        } else if (this.sortBy === header.value) {
          this.sortDesc = true
          this.columnSortExplicit = true
        } else {
          this.sortDesc = false
          this.sortBy = header.value
          this.columnSortExplicit = true
        }
        
        // Reset to page 1 when sorting changes
        this.currentPage = 1
        
        this.updateUrlWithSortParams()
        this.performFilter()
        
        // Restore scroll position after sorting
        this.$nextTick(() => {
          this.restoreScrollPosition()
        })
      }
    },
    async viewFile(fileData) {
      if (fileData.value) {
        if (!this.viewing) {
          this.viewing = true
          const auth = "Bearer " + window.localStorage.session
          const anchor = document.createElement("a")
          document.body.appendChild(anchor)
          const headers = new Headers()
          headers.append("Authorization", auth)
          const route = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${fileData.route}` : fileData.route
          const response = await fetch(route, { headers })
          const blobby = await response.blob()
          const objectUrl = window.URL.createObjectURL(blobby)
          anchor.href = objectUrl
          anchor.target = "blank"
          anchor.click()
          this.viewing = false
        }
      }
    },
    getSlaClass(currentCase) {
      let newClass = "sla-default"
      if (currentCase.serviceLevels && this.bucket && this.bucket.serviceLevel) {
        currentCase.serviceLevels.forEach((sla) => {
          if (sla && sla.serviceLevelCriteria && sla.serviceLevelCriteria.id === this.bucket.serviceLevel.id) {
            if (sla.breachedAt) {
              newClass = "sla-in-breach"
            }
            if (sla.jeopardizedAt && !sla.breachedAt) {
              newClass = "sla-in-jeopardy"
            }
          }
        })
      }
      return newClass
    },
    getSlaColour(currentCase) {
      let newClass = "#6499a6"
      if (currentCase.serviceLevels && this.bucket && this.bucket.serviceLevel) {
        currentCase.serviceLevels.forEach((sla) => {
          if (sla && sla.serviceLevelCriteria && sla.serviceLevelCriteria.id === this.bucket.serviceLevel.id) {
            if (sla.breachedAt) {
              newClass = "error"
            }
            if (sla.jeopardizedAt && !sla.breachedAt) {
              newClass = "tertiary"
            }
          }
        })
      }
      return newClass
    },
    cellValue(item, fieldName, nested) {
      if (item && fieldName && item[fieldName]) {
        if (nested) {
          return item[fieldName]
        }
        return { value: item[fieldName] }
      }
      return "-"
    },
    toggleAll() {
      const toggle = !this.allSelected
      this.selections = []
      if (this.resultTableMode) {
        this.formattedResult.cases.forEach(() => {
          this.selections.push(toggle)
        })
      } else {
        this.cases.forEach(() => {
          this.selections.push(toggle)
        })
      }
    },
    async refreshData() {
      // Triggered by pagination updates
      if (!this.bucketLoading) {
        if (this.dataChanged) {
          this.hideActions = false
          this.resetPagination()
          this.initializeSortFromUrl()
          this.prevPage = 0 // Reset pages..
          const initialPage = this.currentPage && this.currentPage > 0 ? this.currentPage : 1
          this.currentPage = initialPage
          this.pagination.page = initialPage
          if (this.relationData) {
            this.dataProvider.loadAll(this.relationData.caseTypeName, this.relationData.relationship, initialPage)
            const currentCaseType = Helpers.getCaseTypeByCode(this.$store.state, this.relationData.caseTypeName)
            if (currentCaseType && currentCaseType.tasklistTemplates) {
              this.tasklists = currentCaseType.tasklistTemplates
            } else {
              this.tasklists = []
            }
          } else if (this.searchData && this.searchData.caseTypeId) {
            if (this.searchData.caseType) {
              this.hideActions = false
              this.formattedResult = await this.dataProvider.globalSearchSetup(this.searchData)
              this.tasklists = this.searchData.caseType.tasklistTemplates
            } else {
              if (this.searchData.page) {
                this.currentPage = this.searchData.page
                this.pagination.page = this.searchData.page
              }
              this.formattedResult = await this.dataProvider.caseTypeSearchSetup(this.searchData)
              this.tasklists = this.formattedResult.caseType.tasklistTemplates
            }
            if (initialPage > 1 && this.formattedResult && this.formattedResult.caseType) {
              const { sortField, sortDirection } = this.apiSortArgsForSearch()
              const filterField = this.currentFilter && this.currentFilter.field ? this.currentFilter.field : "all_fields"
              const searchResults = await this.dataProvider.searchCases({
                caseTypeId: this.formattedResult.caseType.id,
                page: initialPage - 1,
                itemsPerPage: this.pagination.rowsPerPage,
                searchTerm: this.globalSearchTerm,
                searchableBy: filterField,
                sortDirection: sortDirection,
                sortField: sortField,
              })
              if (searchResults && searchResults.cases) {
                this.formattedResult.cases = searchResults.cases
                if (searchResults.headers) {
                  this.formattedResult.headers = searchResults.headers
                }
              }
            }
          } else {
            this.dataProvider.loadAll(this.caseTypeId, this.bucketId, initialPage)
            if (this.caseType && this.caseType.tasklistTemplates) {
              this.tasklists = this.caseType.tasklistTemplates
            }
          }
          this.dataChanged = false
        } else {
          if (this.searchTerm === null || this.searchTerm === "") {
            this.prevPage = this.pagination.page
            this.dataProvider.reload(this.pagination.page)
          } else {
            // Use a local variable instead of mutating the prop
            const searchField = this.selectedField === "" ? "all_fields" : this.selectedField
            this.performSearch(searchField)
          }
        }
      }
      this.resetSelections()
    },
    async performFilter() {
      this.prevPage = this.pagination.page
      let pageSize = this.pagination.rowsPerPage
      if (pageSize > this.currentFilter.itemCount) {
        pageSize = this.currentFilter.itemCount
      }
      if (this.resultTableMode) {
        const { sortField, sortDirection } = this.apiSortArgsForSearch()
        const searchResults = await this.dataProvider.searchCases({
          caseTypeId: this.formattedResult.caseType.id,
          page: this.pagination.page - 1,
          itemsPerPage: this.pagination.rowsPerPage,
          searchTerm: this.globalSearchTerm,
          searchableBy: this.currentFilter.field,
          sortDirection: sortDirection,
          sortField: sortField,
        })
        this.formattedResult.cases = searchResults.cases
      } else {
        const { sortField, sortDirection } = this.apiSortArgsForSearch()
        this.dataSearcher.searchCases({
          bucketId: this.bucketId,
          page: this.pagination.page,
          itemsPerPage: this.pagination.rowsPerPage,
          searchTerm: this.currentFilter.term,
          searchableBy: this.currentFilter.field,
          sortDirection: sortDirection,
          sortField: sortField,
          relatedData: this.relationData,
        })
      }
      
      // Restore scroll position after filter
      this.$nextTick(() => {
        this.restoreScrollPosition()
      })
    },
    performSearch(searchField = null) {
      this.prevPage = this.pagination.page
      let fieldToUse = searchField || Helpers.formatSnakeCase(this.selectedField)
      if (fieldToUse === "title") {
        fieldToUse = "_title"
      }
      const { sortField, sortDirection } = this.apiSortArgsForSearch()
      this.dataSearcher.searchCases({
        bucketId: this.bucketId,
        page: this.pagination.page,
        itemsPerPage: this.pagination.rowsPerPage,
        searchTerm: this.searchTerm,
        searchableBy: fieldToUse,
        sortDirection: sortDirection,
        sortField: sortField,
      })
      
      // Restore scroll position after search
      this.$nextTick(() => {
        this.restoreScrollPosition()
      })
    },
    resetPagination() {
      this.columnSortExplicit = false
      this.sortBy = ""
      this.sortDesc = false
      this.currentPage = 1
    },
    resetSelections() {
      this.selections = []
      if (this.resultTableMode) {
        this.formattedResult.cases.forEach(() => this.selections.push(false))
      } else {
        this.cases.forEach(() => this.selections.push(false))
      }
    },
    hasValidLink(header, data) {
      if (data === undefined || data === null) {
        return false
      }
      if (header.hasLink) {
        if (data.route !== "" && data.route !== undefined) {
          return true
        }
      }
      return false
    },
    /** GraphQL sort args: only when user (or URL) chose a column — otherwise bucket sortFields apply server-side. */
    apiSortArgsForSearch() {
      if (!this.columnSortExplicit || !this.sortBy || String(this.sortBy).trim() === "") {
        return { sortField: undefined, sortDirection: undefined }
      }
      const sortField = this.sortBy === "title" ? "_title" : this.sortBy
      return { sortField: sortField, sortDirection: this.sortDesc ? "desc" : "asc" }
    },
    updateUrlWithSortParams() {
      const query = { ...this.$route.query }
      if (this.sortBy) {
        query.sortField = this.sortBy
        query.sortDirection = this.sortDesc ? 'desc' : 'asc'
      } else {
        delete query.sortField
        delete query.sortDirection
      }
      // Always include current page number
      if (this.currentPage > 1) {
        query.page = this.currentPage.toString()
      } else {
        delete query.page
      }
      this.$router.replace({ query })
    },
    initializeSortFromUrl() {
      const sortField = this.$route.query.sortField
      const sortDirection = this.$route.query.sortDirection
      const page = this.$route.query.page
      
      if (sortField) {
        this.sortBy = sortField
        this.sortDesc = sortDirection === 'desc'
        this.columnSortExplicit = true
      } else {
        this.columnSortExplicit = false
        this.sortBy = ""
        this.sortDesc = false
      }
      
      if (page) {
        this.currentPage = parseInt(page, 10)
      }
    },
    storeScrollPosition(opts) {
      const includeColumnWidths = !opts || opts.includeColumnWidths !== false
      // Store scroll position of the table container
      const tableElement = this.$refs[this.reference]
      if (tableElement && tableElement.$el) {
        const scrollContainer = tableElement.$el.querySelector('.v-table__overflow')
        if (scrollContainer) {
          this.scrollPosition.x = scrollContainer.scrollLeft
          this.scrollPosition.y = scrollContainer.scrollTop
        }
      }
      if (includeColumnWidths) {
        this.storeColumnWidths()
      }
    },
    restoreScrollPosition() {
      // This method is called when we want to restore scroll position
      // It will call restoreScrollPositionWhenReady which waits for loading to complete
      this.restoreScrollPositionWhenReady()
    },
    restoreScrollPositionWhenReady() {
      // Wait for loading to complete before attempting restoration
      if (this.bucketLoading) {
        // Set up a watcher to restore when loading finishes
        const unwatch = this.$watch('bucketLoading', (newVal) => {
          if (!newVal) {
            unwatch() // Stop watching once loading is done
            this.$nextTick(() => {
              this.attemptScrollRestore()
            })
          }
        })
        return
      }
      
      // Loading is complete, attempt restoration
      this.attemptScrollRestore()
    },
    attemptScrollRestore() {
      // Actual restoration logic - waits for DOM to be ready
      const attemptRestore = (attempts = 0) => {
        const tableElement = this.$refs[this.reference]
        if (tableElement && tableElement.$el) {
          const scrollContainer = tableElement.$el.querySelector('.v-table__overflow')
          if (scrollContainer) {
            // Wait for the table to be fully rendered with data
            const tableRows = scrollContainer.querySelectorAll('tbody tr')
            // Also check that we have data (not just empty table)
            const hasData = this.resultTableMode 
              ? (this.formattedResult.cases && this.formattedResult.cases.length > 0)
              : (this.cases && this.cases.length > 0)
            
            if (tableRows.length > 0 && hasData) {
              // Use requestAnimationFrame for better timing
              requestAnimationFrame(() => {
                scrollContainer.scrollLeft = this.scrollPosition.x
                scrollContainer.scrollTop = this.scrollPosition.y
                
                // Verify scroll was actually applied after a frame
                requestAnimationFrame(() => {
                  const scrollDiff = Math.abs(scrollContainer.scrollLeft - this.scrollPosition.x) + 
                                    Math.abs(scrollContainer.scrollTop - this.scrollPosition.y)
                  
                  if (scrollDiff < 5) {
                    // Also restore column widths
                    this.restoreColumnWidths()
                  } else {
                    // Scroll was reset, try again if we haven't exceeded max attempts
                    if (attempts < 10) {
                      setTimeout(() => attemptRestore(attempts + 1), 100)
                    } else {
                      // Still restore column widths
                      this.restoreColumnWidths()
                    }
                  }
                })
              })
              return
            }
          }
        }
        
        // If not found and we haven't tried too many times, try again
        // Reduced attempts since we're now waiting for loading to complete
        if (attempts < 10) {
          setTimeout(() => attemptRestore(attempts + 1), 100)
        } else {
          // Fallback to observer approach only if we still have a scroll position to restore
          if (this.scrollPosition.x !== 0 || this.scrollPosition.y !== 0) {
            this.restoreScrollPositionWithObserver()
          }
        }
      }
      
      attemptRestore()
    },
    clampBucketColumnWidthPx(raw) {
      if (typeof raw !== "number" || isNaN(raw) || raw <= 0) {
        return null
      }
      const vw = typeof window !== "undefined" ? window.innerWidth : 1200
      const maxW = Math.max(200, Math.min(720, Math.floor(vw * 0.42)))
      const minW = 48
      return Math.min(maxW, Math.max(minW, Math.round(raw)))
    },
    storeColumnWidths() {
      if (this.bucketLoading) {
        return
      }
      const hasData = this.resultTableMode
        ? (this.formattedResult.cases && this.formattedResult.cases.length > 0)
        : (this.cases && this.cases.length > 0)
      if (!hasData) {
        return
      }
      const tableElement = this.$refs[this.reference]
      if (tableElement && tableElement.$el) {
        const headers = tableElement.$el.querySelectorAll("thead th")
        headers.forEach((header, index) => {
          const w = this.clampBucketColumnWidthPx(header.offsetWidth)
          if (w) {
            this.columnWidths[index] = w
          }
        })
      }
    },
    restoreColumnWidths() {
      const attemptRestore = (attempts = 0) => {
        const tableElement = this.$refs[this.reference]
        if (tableElement && tableElement.$el) {
          const headers = tableElement.$el.querySelectorAll("thead th")
          if (headers.length > 0) {
            headers.forEach((header, index) => {
              const stored = this.columnWidths[index]
              const w = this.clampBucketColumnWidthPx(
                typeof stored === "number" ? stored : parseInt(stored, 10)
              )
              if (w) {
                header.style.width = w + "px"
                header.style.minWidth = w + "px"
              }
            })
            return true
          }
        }

        // If not found and we haven't tried too many times, try again
        if (attempts < 10) {
          setTimeout(() => attemptRestore(attempts + 1), 100)
        }
        return false
      }

      attemptRestore()
    },
    // Alternative method using MutationObserver for more reliable timing
    // Only used as a last resort fallback
    restoreScrollPositionWithObserver() {
      // First check if loading is still in progress
      if (this.bucketLoading) {
        // Set up watcher to call this again when loading completes
        const unwatch = this.$watch('bucketLoading', (newVal) => {
          if (!newVal) {
            unwatch()
            this.$nextTick(() => {
              this.restoreScrollPositionWithObserver()
            })
          }
        })
        return
      }
      
      const tableElement = this.$refs[this.reference]
      if (!tableElement || !tableElement.$el) {
        console.log('Observer: Table element not found')
        return
      }
      
      const scrollContainer = tableElement.$el.querySelector('.v-table__overflow')
      if (!scrollContainer) {
        console.log('Observer: Scroll container not found')
        return
      }
      
      let restored = false
      let attempts = 0
      const maxAttempts = 20 // Reduced since we're waiting for loading
      
      // Function to actually restore scroll position
      const doRestore = () => {
        if (restored) return
        
        // Check that we have data
        const hasData = this.resultTableMode 
          ? (this.formattedResult.cases && this.formattedResult.cases.length > 0)
          : (this.cases && this.cases.length > 0)
        
        const tableRows = scrollContainer.querySelectorAll('tbody tr')
        if (tableRows.length > 0 && hasData) {
          // Use requestAnimationFrame for better timing
          requestAnimationFrame(() => {
            scrollContainer.scrollLeft = this.scrollPosition.x
            scrollContainer.scrollTop = this.scrollPosition.y
            
            // Wait a frame and verify it worked
            requestAnimationFrame(() => {
              // Check if scroll was actually applied (accounting for round-off)
              const scrollDiff = Math.abs(scrollContainer.scrollLeft - this.scrollPosition.x) + 
                                  Math.abs(scrollContainer.scrollTop - this.scrollPosition.y)
              
              if (scrollDiff < 5) {
                // Successfully restored
                restored = true
                console.log('Restored scroll position via observer:', this.scrollPosition)
                this.restoreColumnWidths()
              } else {
                // Scroll was reset, try again
                attempts++
                if (attempts < maxAttempts) {
                  setTimeout(doRestore, 100)
                } else {
                  console.log('Observer: Failed to restore scroll after', maxAttempts, 'attempts')
                  this.restoreColumnWidths()
                }
              }
            })
          })
        }
      }
      
      // Create a MutationObserver to watch for changes in the table body
      const observer = new MutationObserver((mutations) => {
        let shouldRestore = false
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if actual table rows were added (not just empty nodes)
            const tableRows = scrollContainer.querySelectorAll('tbody tr')
            const hasData = this.resultTableMode 
              ? (this.formattedResult.cases && this.formattedResult.cases.length > 0)
              : (this.cases && this.cases.length > 0)
            
            if (tableRows.length > 0 && hasData) {
              shouldRestore = true
            }
          }
        })
        
        if (shouldRestore && !restored) {
          doRestore()
        }
      })
      
      // Start observing the table body and scroll container
      const tbody = scrollContainer.querySelector('tbody')
      if (tbody) {
        observer.observe(tbody, { 
          childList: true, 
          subtree: true,
          attributes: false,
          characterData: false
        })
        
        // Also observe the scroll container itself for any DOM changes
        observer.observe(scrollContainer, {
          childList: true,
          subtree: true,
          attributes: false
        })
        
        // Try immediately if rows already exist
        doRestore()
        
        // Fallback timeout - try to restore even if observer doesn't trigger
        setTimeout(() => {
          if (!restored) {
            console.log('Observer: Timeout reached, attempting final restore')
            doRestore()
          }
          
          // Disconnect after a reasonable time
          setTimeout(() => {
            observer.disconnect()
            if (!restored) {
              console.log('Observer: Disconnected without successful restore')
            }
          }, 1000)
        }, 2000)
      } else {
        console.log('Observer: tbody not found, trying periodic restoration')
        // Fallback: try periodic restoration
        const intervalId = setInterval(() => {
          attempts++
          doRestore()
          if (restored || attempts >= maxAttempts) {
            clearInterval(intervalId)
          }
        }, 100)
      }
    },
  },
}
</script>

<style>
.viewer-column {
  align-items: center;
}

.bucket-table-container {
  min-height: 200px;
}

.search-result-table-container {
  min-width: 0;
  max-width: 100%;
  width: 100%;
  overflow: hidden;
}

.search-result-table-container .search-result-data-table {
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

.search-result-table-container .v-table__overflow {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  max-width: 100%;
}

.search-result-table-container table.v-table {
  max-width: none;
  width: auto;
  min-width: 100%;
}

.search-result-table-container .v-datatable__actions {
  width: 100%;
  max-width: 100%;
  flex-wrap: wrap;
}

.my-custom-table .viewer-column.case-presence {
  width: initial;
  min-width: initial;
}

.viewer-column .bucket-field {
  height: 35px;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.5;
}

.my-custom-table {
  min-width: 600px;
  /* position: relative; */
}

.my-custom-table .theme--light.v-table tbody tr:not(:first-child) {
  border-top: initial;
}

.my-custom-table.box-shadow .v-table__overflow {
  border-radius: 3px;
  position: relative;
}

.my-custom-table.shadow-right:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: calc(100% - 16px);
  background: -moz-linear-gradient(left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 1%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0.12) 100%);
  /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 1%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0.12) 100%);
  /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 1%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0.12) 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#1f000000', GradientType=1);
  /* IE6-9 */
}

.my-custom-table.shadow-left:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  /* height: calc(100% - 16px); */
  z-index: 19;
  background: -moz-linear-gradient(left, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0) 99%, rgba(0, 0, 0, 0) 100%);
  /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0) 99%, rgba(0, 0, 0, 0) 100%);
  /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0) 99%, rgba(0, 0, 0, 0) 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#1f000000', endColorstr='#00000000', GradientType=1);
  /* IE6-9 */
}

/* .my-custom-table.no-background .v-datatable__actions   {
  position:absolute;
  right:0;
  bottom:-55px;
  width:100%;
  border-top:none;
} */

.my-custom-table table.v-table thead tr {
  height: 42px;
}

.my-custom-table tr {
  padding: 0 10px !important;
}

.my-custom-table td {
  padding: 0 2px 0 0 !important;
  vertical-align: top;
  min-width: 150px;
}

.my-custom-table td:last-child {
  padding-right: 20px !important;
}

.my-custom-table td:first-child {
  padding-left: 20px !important;
  min-width: 170px;
}

.my-custom-table td.checkbox:first-child {
  min-width: auto;
  min-width: 60px !important;
  width: 60px !important;
  padding-top: 14px !important;
  padding-right: 8px !important;
}

.my-custom-table.on-white-bg td:first-child {
  padding: 0 2px 0 0px !important;
}

.my-custom-table.relation-field-search td:first-child {
  padding-left: 50px !important;
}

.my-custom-table td .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px;
}

.my-custom-table td .v-input__slot {
  margin-bottom: 0px;
}

.my-custom-table td .v-messages__wrapper {
  padding: 5px 0px;
}

.my-custom-table tr {
  border-bottom: none !important;
}

.my-custom-table thead tr th {
  padding: 0 10px 0 0 !important;
  border: none !important;
}

.my-custom-table thead tr th:first-child {
  padding: 0 1px 0 20px !important;
}

.my-custom-table.in-container thead tr th:first-child {
  padding: 0 1px 0 0px !important;
}

.my-custom-table.relation-field-search thead tr th:first-child {
  padding-left: 50px !important;
}

.my-custom-table .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  background: none !important;
}

.field-with-link .v-input__append-inner {
  margin-top: 4px !important;
}

.remove-top-right-border-radius .v-input__slot {
  border-top-right-radius: 0px !important;
}

.remove-top-left-border-radius .v-input__slot {
  border-top-left-radius: 0px !important;
}

.my-custom-table .theme--light.v-table {
  background: none;
}

.my-custom-table .theme--light.v-datatable .v-datatable__actions {
  border-top: none !important;
}

.my-custom-table .v-table__overflow {
  background: white;
}

.my-custom-table .theme--light.v-datatable .v-datatable__actions {
  background: none;
}

.my-custom-table td.remove-max-width {
  width: 4px !important;
}

.my-custom-table .date-field {
  /* width:250px; */
  width: 100%;
  min-width: 250px;
}

.sla-in-breach.theme--light.v-input:not(.v-input--is-disabled) input {
  color: #db444d !important;
  font-weight: 500;
}

.sla-in-breach.v-text-field>.v-input__control>.v-input__slot:after,
.sla-in-breach.v-text-field>.v-input__control>.v-input__slot:before {
  border-color: #db444d !important;
  border-style: solid;
  border-width: thin 0 thin 0;
}

.sla-in-jeopardy.theme--light.v-input:not(.v-input--is-disabled) input {
  color: #f19916 !important;
  font-weight: 500;
}

.sla-in-jeopardy.v-text-field>.v-input__control>.v-input__slot:after,
.sla-in-jeopardy.v-text-field>.v-input__control>.v-input__slot:before {
  border-color: #f19916 !important;
  border-style: solid;
  border-width: thin 0 thin 0;
}

.sla-default.theme--light.v-input:not(.v-input--is-disabled) input {
  color: #6499a6 !important;
  font-weight: 500;
}

.sla-default.v-text-field>.v-input__control>.v-input__slot:after,
.sla-default.v-text-field>.v-input__control>.v-input__slot:before {
  border-color: #6499a6 !important;
  border-style: solid;
  border-width: thin 0 thin 0;
}

.viewers {
  min-width: 10px !important;
}

.table-doc-embedded {
  background: rgba(0, 0, 0, 0.06);
  height: 56px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  position: relative;
  width: 250px;
  display: block;
}

.table-doc-embedded .v-btn {
  margin-top: 10px;
  margin-bottom: 0px;
  display: inline-block !important;
  flex: initial;
  float: left;
  clear: none;
  vertical-align: top;
}

.table-doc-embedded:before {
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
  border-width: thin 0 0 0 !important;
  bottom: -1px;
  content: "";
  left: 0;
  position: absolute;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.table-doc-embedded .btn {
  display: inline-block;
  vertical-align: middle;
}

.table-doc-embedded .doc-added {
  display: none;
  display: inline-block;
  vertical-align: middle;
  padding: 27px 55px 0 12px;
  position: relative;
  font-size: 14px;
}

.table-doc .doc-added label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.54);
  position: absolute;
  top: 10px;
  left: 12px;
}

.table-doc .doc-added .v-btn {
  position: absolute;
  top: 2px;
  right: 0px;
}

.table-doc .doc-added .v-icon {
  vertical-align: middle;
}

td.docs {
  white-space: nowrap;
}

.my-custom-table.on-white-background .v-table__overflow {
  background: rgba(0, 0, 0, 0.06) !important;
}

.my-custom-table.on-white-background .v-input__slot {
  background: white !important;
}

.search-button {
  padding: 0px;
}

.search-button:hover {
  opacity: 0.5;
}

.search-button:before {
  display: none;
}

.remove-button {
  position: sticky;
  z-index: 2;
  right: -1px;
  top: -1px;
  width: 42px;
  height: 36px;
  background: white;
}

.remove-button .v-btn {
  float: right;
}
</style>
